export * from './bussinesshours.component';


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/bussinesshours/index.ts